module.exports = __webpack_public_path__ + "img/fourXiang.876dcdec.svg";